import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { faCheckCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/constants/app-constants';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: false
})
export class StatusComponent implements OnInit, OnChanges {

  @Input() lpData: any;
  @Input() name: string;

  private classSuccess = "mr-2 text-success";
  private classDanger = "mr-2 text-danger";

  private checkCircle = faCheckCircle;
  private timesCircle = faTimesCircle;

  public checkCircleClass = "";
  public iconType: IconDefinition;

  constructor() {}

  ngOnChanges(): void {
    this.setColourCode();
  }

  ngOnInit() {
    this.setColourCode();
  }

  setColourCode() {

    // check for summary component type such as passenger or baggage or cargo or aerodata
    switch (this.name) {

      case 'passenger':

        if (this.lpData.passengerStatus) {
          // set GREEN colour icon if passenger status is TRUE
          this.setIconType(this.checkCircle, this.classSuccess);
        } else {
          // set RED colour icon if NO response received from passenger
          this.setIconType(this.timesCircle, this.classDanger);
        }
        break;

      case 'baggage':

        if (this.lpData.baggageStatus) {
          // set GREEN colour icon if baggage status is TRUE
          this.setIconType(this.checkCircle, this.classSuccess);
        } else {
          // set RED colour icon if NO response received from baggage
          this.setIconType(this.timesCircle, this.classDanger);
        }
        break;

      case 'cargo':

        if (this.lpData.cargoStatus) {
          // set GREEN colour icon if cargo status is TRUE
          this.setIconType(this.checkCircle, this.classSuccess);
        } else {
          // set RED colour icon if NO response received from cargo
          this.setIconType(this.timesCircle, this.classDanger);
        }
        break;

      case 'aerodata':

        if (this.lpData.aerodataStatus) {
          if ( (AppConstants.LOAD_PLANNING === this.lpData.tabName) && this.lpData.baggage.remarks) {
            // set ORANGE colour icon if Load Planning's aerodata response contains any remarks
            this.setIconType(this.checkCircle, "mr-2 text-remarks");
          } else {
            // set GREEN colour icon if aerodata response of LP is BALANCED status for LP or CLST having remarks
            this.setIconType(this.checkCircle, this.classSuccess);
          }

        } else {
          // set RED colour icon if NO response received from aerodata
          this.setIconType(this.timesCircle, this.classDanger);
        }
        break;

      default:
        // set RED colour icon if none of the component type matches
        this.setIconType(this.timesCircle, this.classDanger);
        break;
    }

  }

  setIconType(iconType: IconDefinition, circleClass: string) {
    this.iconType = iconType;
    this.checkCircleClass = circleClass;
  }

}
